import { gql } from '@apollo/client';

export const USER_GET_MANY_WITH_PAGINATION = gql`
  query userGetManyWithPagination(
    $page: Int!
    $limit: Int!
    $orderBy: [OrderByDto]
    $search: String
    $role: UserRoleEnum
  ) {
    userGetManyWithPagination(page: $page, limit: $limit, orderBy: $orderBy, search: $search, role: $role) {
      pagination {
        totalItems
      }
      rows {
        id
        name
        role
        roleAssignedAt
      }
    }
  }
`;

export const USER_UPDATE_ROLE = gql`
  mutation userUpdateRole($input: UserUpdateRoleInput!) {
    userUpdateRole(input: $input) {
      id
      role
      roleAssignedAt
    }
  }
`;
